const getOffset = (element, scroll = 0) => {
	const box = element.getBoundingClientRect();

	return {
		bottom: box.bottom + scroll,
		height: box.height,
		left: box.left,
		top: box.top + scroll,
		width: box.width,
	};
};

const lerp = (x, y, a) => x * (1 - a) + y * a;

const clamp = (a, min = 0, max = 1) => Math.min(max, Math.max(min, a));

const invlerp = (x, y, a) => clamp((a - x) / (y - x));

const mapRange = (inputMin, inputMax, outputMin, outputMax, toMap) => lerp(outputMin, outputMax, invlerp(inputMin, inputMax, toMap));

const deviceType = () => {
	const deviceTest = {
		Android() {
			return navigator.userAgent.match(/Android/i);
		},
		BlackBerry() {
			return navigator.userAgent.match(/BlackBerry/i);
		},
		iOS() {
			return navigator.userAgent.match(/iPhone|iPad|iPod/i);
		},
		Opera() {
			return navigator.userAgent.match(/Opera Mini/i);
		},
		Windows() {
			return navigator.userAgent.match(/IEMobile/i);
		},
		check() {
			return (deviceTest.Android() || deviceTest.BlackBerry() || deviceTest.iOS() || deviceTest.Opera() || deviceTest.Windows());
		},
	};

	return deviceTest.check() ? 'Mobile' : 'Desktop';
};

// prettier-ignore
export {
	getOffset,
	lerp,
	clamp,
	invlerp,
	mapRange,
	deviceType,
};
